export default __webpack_public_path__ + "static/media/5.3d1a4b5a.jpg";